export { PostHogProvider } from './PostHogProvider';
export { trackEvent } from './trackEvent';
export { setPersonProperties } from './setPersonProperties';
export type { PersonProperties } from './types';
export type { CaptureOptions } from 'posthog-js';
export { useFeatureFlag } from './useFeatureFlag';
export { POSTHOG_UI_HOST, PH_NO_CAPTURE_CLASS, isPostHogConfigured } from './config';
